import logoImg from "assets/logo.png";
import { clsx } from "clsx";
import type { HTMLAttributes } from "react";

export function Logo({ className, ...restProps }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={clsx("brand-logo", className)} {...restProps}>
      <img src={logoImg} alt="brand logo" className="h-full object-cover" />
    </div>
  );
}
